module.exports = __webpack_public_path__ + "static/media/02_Special_Ep4.1f355535.jpg";